import { SwapKitApi } from "@swapkit/api";

import { logger } from "../../logger";

export async function getIsFeatureAvailable() {
  try {
    const response = await SwapKitApi.getMimirInfo({ type: "thorchain" });

    if (!response) {
      logger.error("Empty response in `getIsFeatureAvailable`");
    }

    // HALT flags are boolean -  0 = no halt, > 0 = halt
    // https://dev.thorchain.org/concepts/network-halts.html#network-halts
    return {
      // features
      thornames: response?.THORNAMES > 0,

      // halts
      thorchain: response?.HALTTHORCHAIN === 0,
    };
  } catch (error) {
    logger.error("Error in `getIsFeatureAvailable`", error);

    return {
      thornames: false,
      thorchain: false,
    };
  }
}
